import React from 'react'

import Header from '../components/Header/Header'

import Navbar from '../components/Navbar/Navbar'
import Card from '../components/Cards/Card'

const Home = () => {
  return (
    <div>
        <Navbar/>
        <Header/>
        <Card/>
    </div>
  )
}

export default Home